import { IBCS, varianceColor } from './HatchPattern';
import { formatEur, formatPct } from './IbcsTooltip';

/**
 * Compact inline variance indicator: absolute delta + pct in semantic colour.
 * Used in matrix cells and KPI tiles for month-over-month / YoY deltas.
 */
interface VarianceBarProps {
    amount: number | null;
    pct?: number | null;
    forecast?: boolean;
    compact?: boolean;
}

export default function VarianceBar({ amount, pct, forecast, compact }: VarianceBarProps) {
    if (amount == null) return <span className="text-gray-400 text-xs">—</span>;
    const color = varianceColor(amount, { forecast });
    const arrow = amount > 0 ? '▲' : amount < 0 ? '▼' : '•';
    return (
        <span
            className={`inline-flex items-baseline gap-1 font-mono tabular-nums ${compact ? 'text-xs' : 'text-sm'}`}
            style={{ color }}
        >
            <span>{arrow}</span>
            <span>{formatEur(Math.abs(amount))}</span>
            {pct != null && <span className="opacity-80">({formatPct(pct)})</span>}
        </span>
    );
}

export { IBCS };
